import React, { useState, useEffect } from "react";
import { Tooltip, Paper, Grid } from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import UserCreate from "./UserCreate";

const UserMaster = () => {
  const [userName, setUserName] = useState([]);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [UserID, setUserID] = useState('');
  const [Count, setCount] = useState();
  const [response, fetchData] = UseFetchData();

  const openModal = (row) => {
    debugger;
    setOpen(true);
    setUserID(row.id);
  };

  const handleOpenModal = () => {
    setUserID('');
    setOpen(true);
  };

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("SearchString", userName);
    fetchData("User/List", bodyFormData);
  };

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
        // renderCell: (params) => (<strong> <a href="javascript:;"  onClick={() => { openModal(params.getValue("id")); }} >Edit</a> </strong> ), 
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "EmpCode",
        headerName: "Emp Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "EmpName",
        headerName: "Emp Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "UserName",
        headerName: "User Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "UserType",
        headerName: "User Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "DOB",
        headerName: "DOB",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "DOJ",
        headerName: "DOJ",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Department",
        headerName: "Department",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "GroupName",
        headerName: "GroupName",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "Address1",
        headerName: "Address1",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.Address1} >
            <span className="table-cell-trucate">{params.row.Address1}</span>
          </Tooltip>
        ),
      },
      {
        field: "Address2",
        headerName: "Address2",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.Address2} >
            <span className="table-cell-trucate">{params.row.Address2}</span>
          </Tooltip>
        ),
      },
      {
        field: "Email",
        headerName: "Email",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "Mobile",
        headerName: "Mobile",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "Phone",
        headerName: "Phone",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "Remarks",
        headerName: "Remarks",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.Remarks} >
            <span className="table-cell-trucate">{params.row.Remarks}</span>
          </Tooltip>
        ),
      },
      {
        field: "IsActive",
        headerName: "IsActive",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]);

  useEffect(() => {
    PopulateData();
  }, [])

  return (
    <Paper elevation={0} >
      <Grid container direction="row" style={{ marginTop: -10 }} >
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 10, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Input
            label="User Name"
            name="userName"
            id="UserName"
            style={{ width: "180px" }}
            onChange={(e) => setUserName(e.target.value)}
          />
        </Grid>
        <Grid xs={6} md={4} sm={8} lg={4} xl={3} >
          <div style={{ width: "100%", margin: 10 }} >
            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
              <BiztranControls.Button
                text="Search"
                startIcon={<SearchIcon />}
                onClick={() => {
                  PopulateData();
                }}
              />
            </div>
            <div style={{ float: "left", marginTop: 15, marginLeft: 7 }}>
              <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
            </div>
            <div style={{ float: "left", marginTop: 0, paddingLeft: 10, width: "30%" }}>
              <BiztranControls.Button
                text="ADD NEW"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  handleOpenModal();
                }}
              />
            </div>
          </div>

        </Grid>

      </Grid>
      <ModalFrame
        title="User Details"
        maxWidth="sm"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <UserCreate
          UserID={UserID}
          setOpen={setOpen}
          PopulateData={PopulateData}
        />
      </ModalFrame>
      <BiztranControls.DataGrid
        rowHeight={25}
        headerHeight={34}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        //Height="530px"
        //Height="700px"
        autoHeight={true}
        Width="100%"
      />

    </Paper>

  );
};

export default UserMaster;
